import { OfferingAllowances } from '../model/data';

import type {
	CloudOfferingKey,
	OfferingSKU,
} from '@/components/wpl/pricing/src/price-finder/constants';
import { getContentfulProductCatalogClient } from '../../../../uniform/components/pricing-calculator/src/client/contentful-clients';

import { transform } from './transform.ts';
import { validate } from './validate';

export const fetchProductCatalogData = async (
	offeringSKUs: OfferingSKU<CloudOfferingKey>[],
): Promise<OfferingAllowances> => {
	const client = getContentfulProductCatalogClient();
	const offerings = await client.getCCPPricingData(offeringSKUs);
	const data = transform(offerings);
	validate(data);
	return data;
};
